import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import api from "@/lib/api";

export default function Specialties() {
  const nav = useNavigate();
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/public/specialties").then(r => setItems(r.data.specialties || [])); }, []);

  return (
    <section className="pgwrap">
      <span className="pg-eyebrow">Services</span>
      <h2 className="pg-h2">Specialties</h2>
      <p className="pg-lead">Our verified specialists cover a broad range of conditions. Choose a specialty to see the conditions it commonly treats and book a review.</p>
      <div className="grid-auto" style={{ marginTop: 24 }} data-testid="specialties-grid">
        {items.map(s => (
          <div className="card2 spec-card" key={s.id} onClick={() => nav(`/specialty/${s.id}`)} data-testid={`specialty-${s.name}`}>
            <h4>{s.name}</h4>
            <div className="dz">{(s.diseases || []).map((d, i) => <span key={i}>{d}</span>)}</div>
            <span className="arrow">View specialty <ArrowRight size={15} /></span>
          </div>
        ))}
      </div>
    </section>
  );
}
